import type { PannelProps } from '@/app/[locale]/(auth)/signup/(funnel)/PannelType';
import styles from '@/app/[locale]/(auth)/signup/(funnel)/RegisterComp.module.scss';
import SubmitBtn from '@/legacy/components/btn/SubmitBtn';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useTransAuth } from '@/@shared/hooks/useTranslations';

const RegisterDone = ({ locale, onNext }: PannelProps) => {
	const t = useTransAuth('signup.complete');

	const handleClick = async () => {
		onNext();
	};

	return (
		<div className={'fdc ct mid'} style={{ top: '72px', width: '100%' }}>
			<div className={styles.done}>
				<span className={styles.line1}>{t('title')}</span>
				<div className={styles.line2}>
					<span>{t('subtitle')}</span>
				</div>
			</div>

			<div className={styles.bigLogo}>
				<Image alt="BigLogo" fill src="/img/BigLogo.png" />
			</div>

			<div className={styles.goToLogin}>
				<SubmitBtn isSubmitting={false} isValid={true} onClick={handleClick} text={t('goToLogin')} type="button" />
			</div>
		</div>
	);
};

export default RegisterDone;
